import { useEffect, useRef } from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import Lenis from "lenis";
import { Toaster } from "sonner";
import Home from "@/pages/Home";
import ServicePage from "@/pages/ServicePage";
import ProductPage from "@/pages/ProductPage";
import ContactPage from "@/pages/ContactPage";
import LegalPage from "@/pages/LegalPage";
import CountryVisaPage from "@/pages/CountryVisaPage";
import BlogIndex from "@/pages/BlogIndex";
import BlogPost from "@/pages/BlogPost";
import AdminOrders from "@/pages/AdminOrders";
import AccessibilityPage from "@/pages/AccessibilityPage";
import { ChatWidget } from "@/components/ChatWidget";
import { AccessibilityWidget } from "@/components/AccessibilityWidget";

function ScrollManager({ lenisRef }) {
  const { pathname } = useLocation();
  useEffect(() => {
    const lenis = lenisRef.current;
    if (lenis) {
      lenis.scrollTo(0, { immediate: true });
    }
    // Fallback for reduced-motion / lenis not ready
    window.scrollTo(0, 0);
  }, [pathname, lenisRef]);
  return null;
}

function App() {
  const lenisRef = useRef(null);

  useEffect(() => {
    const lenis = new Lenis({ duration: 1.1, smoothWheel: true });
    lenisRef.current = lenis;
    let raf;
    const loop = (time) => {
      lenis.raf(time);
      raf = requestAnimationFrame(loop);
    };
    raf = requestAnimationFrame(loop);
    return () => {
      cancelAnimationFrame(raf);
      lenis.destroy();
      lenisRef.current = null;
    };
  }, []);

  return (
    <div className="App">
      <div className="grain-fixed" aria-hidden="true" />
      <BrowserRouter>
        <ScrollManager lenisRef={lenisRef} />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/contact" element={<ContactPage />} />
          <Route path="/privacy-policy" element={<LegalPage slug="privacy-policy" />} />
          <Route path="/guarantee" element={<LegalPage slug="guarantee" />} />
          <Route path="/drug-free-workplace-policy" element={<LegalPage slug="drug-free-workplace-policy" />} />
          <Route path="/blog" element={<BlogIndex />} />
          <Route path="/blog/:slug" element={<BlogPost />} />
          <Route path="/visa/:country" element={<CountryVisaPage />} />
          <Route path="/product/:slug" element={<ProductPage />} />
          <Route path="/admin" element={<AdminOrders />} />
          <Route path="/accessibility" element={<AccessibilityPage />} />
          <Route path="/:slug" element={<ServicePage />} />
        </Routes>
        <ChatWidget />
        <AccessibilityWidget />
      </BrowserRouter>
      <Toaster position="top-center" richColors />
    </div>
  );
}

export default App;
